import Api from '.';

class BotSettingApi extends Api {
  base_endpoint = 'bot-settings';

  all(botId, params) {
    return this.doRequest('get', botId, params);
  }

  update(botId, id, data) {
    return this.doRequest('put', `${botId}/${id}`, data);
  }
}

export default new BotSettingApi();
